import schemeAnalytics from '../schemes/schemeAnalytics';
import {mapState} from "vuex";
let {groupingLabels} = schemeAnalytics;
export default {
    /**
     * данные компонента
     * @property {object} filterData - данные фильтра
     * @property {object} filterDataSelected - выбранные данные фильтра
     */
    data: () => ({
        groupingEntitySingle: "",
        groupingEntityMulti: ""
    }),
    computed: {
        /**
         * проксируем состояния из стора
         * @property {Object} filterSelected - выбранное в фильтре
         */
        ...mapState({
            filterSelected: state => state.filterSelected
        }),
    },
    methods: {

    },
    watch: {
        filterSelected(){
            let groupingEntityData = groupingLabels[this.filterSelected.grouping_entity];
            let {single = '', multi = ''} = groupingEntityData;
            this.groupingEntitySingle = single;
            this.groupingEntityMulti = multi;
        }
    }
}